/**
 * Centralized TanStack Query key factory. Hook consumers should never build
 * keys by hand — go through this object so invalidation stays consistent.
 *
 * Pattern borrowed from https://tkdodo.eu/blog/effective-react-query-keys —
 * flat, readonly tuples that compose from generic to specific.
 */
export const shoppingListKeys = {
  all: ['shopping-lists'] as const,
  lists: () => [...shoppingListKeys.all, 'list'] as const,
  detail: (id: string) => [...shoppingListKeys.all, 'detail', id] as const,
};
